/**
 *
 * EditScheduleDates
 *
 */

import React, { Component } from "react"
// import PropTypes from 'prop-types';
import { DatePicker, Checkbox, Select, Drawer, Button } from "antd"
import { Helmet } from "react-helmet"
import moment from "moment"
import { isEqual, get, filter } from "lodash"
import ModalCustom from "../ModalCustom"
import "./index.less"
import { getDaysFrequencyRange } from "../../utils/segment/Measure/measureTrack"
import { ClockCircleOutlined } from "@ant-design/icons"
import { buttonAction_btns } from "../Snowplow/config2"

const CheckboxGroup = Checkbox.Group
const { Option } = Select

// id_measure_status
class EditScheduleDates extends Component {
  state = {
    date_start: undefined,
    date_end: undefined,
    date_resend: [],
    hour_send: undefined,
    hour_close: undefined,
    hour_resend: undefined,
    editMeasureSegment: [],
    date_start_original: undefined,
    date_end_original: undefined,
    hour_send_original: undefined,
    hour_close_original: undefined,
    days_resend_original: undefined,
    hours: [],
    hoursClose: [],
  }

  componentDidMount = () => {
    const { hour_resend, date_start } = this.props.datesProgramming
    this.setState({
      date_end: moment(new Date(this.props.datesProgramming.date_end)),
      hour_resend: hour_resend ? moment(new Date(hour_resend)) : undefined,
      date_resend: get(this.props.datesProgramming, "date_resend", []),
      date_start: date_start ? moment(new Date(date_start)) : undefined,
      hour_send: moment(new Date(this.props.datesProgramming.date_start)),
      hour_close: moment(new Date(this.props.datesProgramming.date_end)),
    })
    this.generateHours()
    this.generateHoursClose();
  }

  generateHours = () => {
    const { hours } = this.state
    for (let hour = 0; hour < 24; hour++) {
      hours.push(moment({ hour }).format("HH:mm"))
      hours.push(
        moment({
          hour,
          minute: 30,
        }).format("HH:mm")
      )
    }
    this.setState({ hours })
  }
  generateHoursClose = () => {
    const { hoursClose } = this.state
    let date_start = this.state.date_start;
    let date_end = this.state.date_end;
    let daySame=false;

    if (date_start && date_end && date_start.isSame(date_end, 'day')) {
      daySame=true;
    }

    let hour_send= moment(this.state.hour_send).format("HH:mm");


    for (let hour = 0; hour < 24; hour++) {

      let hourFormatted = moment({ hour }).format("HH:mm");
      let halfHourFormatted = moment({ hour, minute: 30 }).format("HH:mm");

      if (daySame) {
        if (hourFormatted > hour_send) {
          hoursClose.push(hourFormatted);
        }
        if (halfHourFormatted > hour_send) {
          hoursClose.push(halfHourFormatted);
        }
      } else {
        hoursClose.push(hourFormatted);
        hoursClose.push(halfHourFormatted);
      }
    }
    this.setState({ hoursClose })
  }
  getDisableTime= (selectedHour) => {
    if (
      this.state.date_start &&
      moment().format("DD-MM-YYYY") ===
        this.state.date_start.format("DD-MM-YYYY") &&
      selectedHour <= moment().format("HH:mm")
    ) {
      return true;
    }
    return false;
  }
  getDisableTimeClose = (selectedHour) => {
    if (
      this.state.date_end &&
      moment().format("DD-MM-YYYY") ===
        this.state.date_end.format("DD-MM-YYYY") &&
      selectedHour <= moment().format("HH:mm")
    ) {
      return true;
    }
    if(this.state.date_end){
      if(this.state.date_end.isBefore(moment(), 'day')) return true;
    }

    const { date_start, date_end, hour_send } = this.state;
    const daySame = date_start && date_end && date_start.isSame(date_end, 'day');

    if (daySame && hour_send && selectedHour <= hour_send.format("HH:mm") ||
    (daySame && hour_send && moment(selectedHour, 'HH:mm').diff(moment(hour_send.format("HH:mm"), 'HH:mm'), 'hours')< 1)) {
      return true;
    }
    return false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !isEqual(nextProps, this.props) &&
      !nextProps.isLoadingDatesProgramming
    ) {
      const { hour_resend, date_start, date_end } = nextProps.datesProgramming
      this.setState({
        date_end: date_end ? moment(new Date(date_end)) : undefined,
        hour_resend: hour_resend ? moment(new Date(hour_resend)) : undefined,
        date_resend: get(nextProps.datesProgramming, "date_resend", []),
        date_start: date_start ? moment(date_start) : undefined,
        hour_send: moment(new Date(nextProps.datesProgramming.date_start)),
        hour_close: moment(new Date(nextProps.datesProgramming.date_end)),
      })
      this.setOriginalAttributesSegment(date_end, date_start)
    }
  }

  setOriginalAttributesSegment = (date_end, date_start) => {
    const date_start_original = date_start
      ? moment(new Date(date_start))
      : undefined
    const date_end_original = date_end ? moment(new Date(date_end)) : undefined
    const hour_send_original = moment(
      new Date(this.props.datesProgramming.date_start)
    )
    const hour_close_original = moment(new Date(this.props.datesProgramming.date_end))
    this.setState({
      date_end_original,
      date_start_original,
      hour_send_original,
      hour_close_original,
      days_resend_original: getDaysFrequencyRange(
        get(this.props.datesProgramming, "date_resend", []),
        date_start_original,
        date_end_original
      ),
    })
  }

  saveSettingSegment = (name, isEqualAttribute) => {
    const { editMeasureSegment } = this.state
    const index = editMeasureSegment.indexOf(name)
    if (
      ((isEqualAttribute === false || isEqualAttribute === "delete") &&
        index == -1) ||
      isEqualAttribute === "update"
    ) {
      editMeasureSegment.push(name)
    }
    if ((isEqualAttribute || isEqualAttribute === "delete") && index != -1) {
      editMeasureSegment.splice(index, 1)
    }
    this.setState({ editMeasureSegment })
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
    if (name === "date_start" || name === "date_end" || name === "hour_send") {
      const { date_start, date_end } = this.state;
    const daySame = date_start && date_end && date_start.isSame(date_end, 'day');
    if(daySame){
      this.props.setStateFrom("hour_close", undefined)
      this.setState({
        hour_close: undefined,
      })
    }
    }

  }

  disabledEndDate = (date_end) => {
    const date_start = this.state.date_start.clone()

    if (!date_end || !date_start) return false
    const formattedEndDate = moment(date_end.format("YYYY-MM-DD"));
    const formattedStartDate = this.state.date_start.format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    const isBeforeStartDate = formattedEndDate.isBefore(formattedStartDate);
    const isBeforeAsToday = this.props.measureStatus==3?formattedEndDate.isBefore(today) : formattedEndDate.isBefore(this.state.date_end_original.format("YYYY-MM-DD"));
    const isOptimizedCase = [3, 4].includes(this.props.measureStatus);
    return isBeforeStartDate || (isOptimizedCase && isBeforeAsToday);

  }

  disabledButtonSave = () => {
    const { hour_resend, date_start } = this.props.datesProgramming

    const dateFromProps = {
      date_start: date_start || undefined,
      hour_send: this.props.datesProgramming.date_start,
      hour_close: this.props.datesProgramming.date_end,
      date_end: this.props.datesProgramming.date_end,
      date_resend: get(this.props.datesProgramming, "date_resend", []),
      hour_resend,
    }

    const dateFromState = {
      date_start: this.state.date_start
        ? moment(new Date(this.state.date_start)).format("YYYY/MM/DD HH:mm:ss")
        : undefined,
      hour_send: moment(new Date(this.state.hour_send)).format(
        "YYYY/MM/DD HH:mm:ss"
      ),
      hour_close: moment(new Date(this.state.hour_close)).format("YYYY/MM/DD HH:mm:ss"),
      date_end: this.state.date_end
      ? moment(new Date(this.state.date_end)).format("YYYY/MM/DD HH:mm:ss")
      : undefined,
      date_resend: this.state.date_resend,
      hour_resend: this.state.hour_resend
        ? moment(new Date(this.state.hour_resend)).format("YYYY/MM/DD HH:mm:ss")
        : "",
    }

    if (this.state.date_resend.length && !this.state.hour_resend) {
      return true
    }

    if (!this.state.date_resend.length && this.state.hour_resend) {
      return true
    }

    if (!this.state.date_end) return true
    if (!this.state.hour_close) return true

    return isEqual(dateFromProps, dateFromState)
  }

  getDaysForward = () => {
    const newDays = []
    let noShowFirstDate = 0
    const plainOptions = [
      { label: "Lu", value: "lu" },
      { label: "Ma", value: "ma" },
      { label: "Mi", value: "mi" },
      { label: "Ju", value: "ju" },
      { label: "Vi", value: "vi" },
      { label: "Sá", value: "sá" },
      { label: "Do", value: "do" },
    ]

    if (this.state.date_start && this.state.date_end) {
      const cloneStartDate = this.state.date_start.clone()
      const cloneEndDate = this.state.date_end.clone().add(1, "days")
      // let cloneEndDate = this.state.date_end.clone().add(1, 'days');
      if (cloneStartDate <= cloneEndDate) {
        while (
          cloneStartDate.format("DD-MM-YYYY") !==
          cloneEndDate.format("DD-MM-YYYY")
        ) {
          if (
            this.state.date_start.format("dd") === cloneStartDate.format("dd")
          ) {
            noShowFirstDate++
          }

          newDays.push(cloneStartDate.format("dd"))
          cloneStartDate.add(1, "days")
        }
      }
    }

    if (newDays.length) {
      if (
        this.state.date_start.format("DD-MM-YYYY") ===
        this.state.date_end.format("DD-MM-YYYY")
      )
        return plainOptions
      return filter(plainOptions, (item) => {
        if (
          noShowFirstDate === 1 &&
          this.state.date_start.format("dd") === item.value
        )
          return
        return newDays.includes(item.value)
      })
    }

    return plainOptions
  }

  sendToServer = () => {
    const params = {
      // idMeasurement: this.props.idSurvey,
      idMeasure: this.props.idSurvey,
      params: {
        date_start: `${this.state.date_start.format(
          "DD/MM/YYYY"
        )} ${this.state.hour_send.format("HH:mm")}:00`,
        date_end: `${this.state.date_end.format(
          "DD/MM/YYYY"
        )} ${this.state.hour_close.format("HH:mm")}:00`,
        date_resend: this.state.date_resend.length
          ? this.state.date_resend
          : [],
        editChangesSegment: this.state.editMeasureSegment,
        hour_resend: this.state.date_resend
          ? this.state.hour_resend
            ? `${this.state.hour_resend.format("HH:mm")}:00`
            : undefined
          : undefined,
        id_measure_status: this.props.measureStatus,
      },
    }

    this.setState({ editMeasureSegment: [] })
    this.props.getDatesWatcher(params)
    // this.props.editDatesWatcher(params);
  }

  disabledHours = () => {
    const hoursDisabled = []
    let init = 0

    if (
      moment().format("DD-MM-YYYY") ===
      this.state.date_start.format("DD-MM-YYYY")
    ) {
      while (init <= new Date().getHours()) {
        hoursDisabled.push(init)
        init++
      }
    }
    return hoursDisabled
  }
  renderFooter = () => {

    return (
      <div
        style={{
          textAlign: "right",
        }}>
        <Button
          style={{ marginRight: 8 }}
          onClick={() => {
            this.props.setStateFrom("editProgrammingModal", false)
          }}>
          Cancelar
        </Button>
        <Button
          form="editProgrammingModal"
          key="submit"
          htmlType="submit"
          type="primary"
          disabled={this.disabledButtonSave()}
          loading={this.props.isLoadingDatesProgramming}
          onClick={() =>{
            this.sendToServer()
            this.props.setStateFrom("editProgrammingModal", false)
            buttonAction_btns("Editar programación - Editar")}}>
          { "Guardar"}
        </Button>
      </div>
    )
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <style>{`
            .ant-calendar-picker-container.ant-calendar-picker-container-placement-bottomLeft:first-child {
              // border: 1px solid blue;
              z-index: none;
            }
          `}</style>
        </Helmet>
        <Drawer
          textButton="Editar"
          width={680}
          title="Editar programación"
          visible={this.props.modalOpen}
          footer={this.renderFooter()}
          textAlign="left"
          onClose={() =>{
            this.props.setStateFrom("editProgrammingModal", false)
            Intercom('update', { hide_default_launcher: false });
          }
            
            
          }
          onOk={() => {
            this.sendToServer()
            this.props.setStateFrom("editProgrammingModal", false)
            buttonAction_btns("Editar programación - Editar")
            Intercom('update', { hide_default_launcher: false });
          }}>
          <div>
            <span className="measurement-schedule-survey-item-title">
            Inicio y envió<span className="red">*</span>
            </span>
            <p className="text-p">
            Selecciona cuándo iniciará y se enviará la encuesta:
            </p>
            <DatePicker
              allowClear={false}
              disabled={!(this.props.measureStatus === 2)}
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
              style={{ width: 215 }}
              format="DD-MM-YYYY"
              value={this.state.date_start}
              onChange={(e) => {
                this.saveSettingSegment(
                  "date_start",
                  e.isSame(this.state.date_start_original)
                )
                if (this.state.date_end) {
                  this.setStateFrom("date_start", e)
                  if (e.isAfter(this.state.date_end)) {
                    this.setStateFrom("date_end", undefined)
                  }
                  return
                }

                this.setStateFrom("date_start", e)
              }}
            />
            <Select
              style={{ width: 215,left:15  }}
              value={
                this.state.hour_send
                  ? this.state.hour_send.format("HH:mm")
                  : undefined
              }
              placeholder="Seleccionar hora"
              disabled={!(this.props.measureStatus === 2)}
              onChange={(time) => {
                this.setStateFrom("hour_send", time)
                this.saveSettingSegment(
                  "hourd_send",
                  moment(`${this.state.date_start} ${time}`).isSame(
                    this.state.hour_send_original
                  )
                )
              }}
              suffixIcon={<ClockCircleOutlined />}>
              {this.state.hours.map((h, hi) => (
                <Option disabled={this.getDisableTime(h)} value={h} key={hi}>
                  {h}
                </Option>
              ))}
            </Select>
          </div>
          <div className="edit-schedules-dates-item">
            <span className="measurement-schedule-survey-item-title">
            Fin y cierre<span className="red">*</span>
            </span>
            <p className="text-p">
             Selecciona cuándo finalizará y cerrará la encuesta:
            </p>
            <DatePicker
              allowClear={false}
              disabledDate={this.disabledEndDate}
              format="DD-MM-YYYY"
              value={this.state.date_end}
              style={{ width: 215 }}
              onChange={(e) => {
                this.setStateFrom("date_end", e)
                this.saveSettingSegment(
                  "date_end",
                  e.isSame(this.state.date_end_original)
                )
              }}
            />
            <Select
                name="horaCierre"
                style={{ width: 215, left:15 }}
                value={
                  this.state.hour_close
                    ? this.state.hour_close.format("HH:mm")
                    : undefined
                }
                placeholder="Hora de cierre"
                disabled={!this.state.date_end}
                allowClear
                onChange={(time) => {
                  this.setStateFrom("hour_close", time)
                this.saveSettingSegment(
                  "hourd_close",
                  moment(`${this.state.date_end} ${time}`).isSame(
                    this.state.hour_close_original
                  )
                )
                }}
                suffixIcon={<ClockCircleOutlined />}>
                {this.state.hoursClose.map((h, hi) => (
                  <Option
                    name="opcionHoraCierre"
                    disabled={this.getDisableTimeClose(h)}
                    value={h}
                    key={hi}>
                    {h}
                  </Option>
                ))}
              </Select>
          </div>
          <div className="edit-schedules-dates-item">
            <span className="measurement-schedule-survey-item-title">
              Días de reenvío
            </span>
            <p className="text-p">
              Selecciona los días de reenvío de la encuesta para aquellos
              colaboradores que no la hayan contestado aún:
            </p>
            <CheckboxGroup
              disabled={
                this.state.date_start && this.state.date_end
                  ? this.state.date_start.format("DD-MM-YYYY") ===
                    this.state.date_end.format("DD-MM-YYYY")
                  : false
              }
              className="measurement-schedule-survey-days"
              options={this.getDaysForward()}
              value={this.state.date_resend}
              onChange={(value) => {
                this.setState({ date_resend: value })
                this.saveSettingSegment(
                  "days_resend",
                  this.state.days_resend_original ===
                    getDaysFrequencyRange(
                      value,
                      this.state.date_start,
                      this.state.date_end
                    )
                )
              }}
            />
          </div>
          <div className="edit-schedules-dates-item">
            <span className="measurement-schedule-survey-item-title">
              Horario de reenvío
            </span>
            <p className="text-p">
              Selecciona la hora en la que se reenviará la encuesta a los
              colaboradores:
            </p>
            <Select
              style={{ width: 171 }}
              value={
                this.state.hour_resend
                  ? this.state.hour_resend.format("HH:mm")
                  : undefined
              }
              placeholder="Seleccionar hora"
              disabled={
                this.state.date_start && this.state.date_end
                  ? this.state.date_start.format("DD-MM-YYYY") ===
                    this.state.date_end.format("DD-MM-YYYY")
                  : false
              }
              onChange={(time, timeString) =>
                this.setStateFrom("hour_resend", time)
              }
              allowClear
              suffixIcon={<ClockCircleOutlined />}>
              {this.state.hours.map((h, hi) => (
                <Option value={h} key={hi}>
                  {h}
                </Option>
              ))}
            </Select>
          </div>
        </Drawer>
      </React.Fragment>
    )
  }
}

EditScheduleDates.propTypes = {}

export default EditScheduleDates
